import { OpenAPI } from '@lhb/api/idp';

export function getSuccessUrl(requestId: string, returnUrl: string) {
  return `${
    OpenAPI.BASE
  }/BankIdAuthorize/validate/${requestId}?ReturnUrl=${encodeURIComponent(
    returnUrl,
  )}`;
}
